import React from "react";
import { ASSEMBLY_TAGLINE, SOCIAL_LINKS } from "../utils";

/**
 * Social profile links (Instagram, YouTube, LinkedIn) for marketing footers.
 * @param {Object} props
 * @param {string} [props.className] Optional wrapper classes.
 * @param {"center"|"end"} [props.align] Horizontal alignment for heading and icon row.
 * @returns {JSX.Element}
 */
export function ConnectWithUsBlock({ className, align = "center" }) {
  const end = align === "end";
  const layoutClass = end
    ? "flex flex-col items-end gap-3 text-right"
    : "flex flex-col items-center gap-3";
  const rootClass = className ? `${layoutClass} ${className}` : layoutClass;
  return (
    <div className={rootClass}>
      <h2
        className={`text-sm font-semibold text-text-primary ${end ? "text-right" : "text-center"}`}
      >
        Connect with us
      </h2>
      <ul
        className={`flex flex-wrap gap-4 ${end ? "justify-end" : "justify-center"}`}
      >
        {SOCIAL_LINKS.map(({ label, href, iconSrc }) => (
          <li key={label}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex size-10 items-center justify-center rounded-full border border-hero-glass-border bg-hero-glass-bg backdrop-blur-sm transition-colors duration-300 hover:border-border-entry hover:bg-highlight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
              aria-label={label}
            >
              <img
                src={iconSrc}
                alt=""
                width={20}
                height={20}
                className="size-6 object-contain"
                decoding="async"
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function Footer() {
  return (
    <footer className="bg-primary py-10 text-text-muted">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:items-center md:gap-6 lg:gap-10">
          <div className="min-w-0 text-left">
            <p className="text-xl font-bold text-text-primary">Assembly</p>
            <p className="mt-1 text-sm text-text-secondary">{ASSEMBLY_TAGLINE}</p>
          </div>
          <p className="text-center text-sm md:px-2">
            &copy; {new Date().getFullYear()} Assembly. All rights reserved.
          </p>
          <div className="flex min-w-0 justify-end">
            <ConnectWithUsBlock align="end" />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
